import React__default from 'react';
var AppStores = function AppStores() {
  return /* @__PURE__ */React__default.createElement("div", {
    className: "footer-cp__links-group"
  }, /* @__PURE__ */React__default.createElement("h2", {
    className: "footer-cp__title"
  }, "Baixe nosso aplicativo"), /* @__PURE__ */React__default.createElement("ul", {
    className: "footer-cp__links-list"
  }, /* @__PURE__ */React__default.createElement("li", null, /* @__PURE__ */React__default.createElement("a", {
    href: "https://consumidorpositivo.onelink.me/3ote/x1wo22j1",
    target: "_blank"
  }, /* @__PURE__ */React__default.createElement("img", {
    className: "footer-cp__image",
    src: "https://www.consumidorpositivo.com.br/images/download-play-store.svg",
    alt: "Link para baixar o app na Play Store",
    loading: "lazy",
    width: "205px",
    height: "64px"
  }))), /* @__PURE__ */React__default.createElement("li", null, /* @__PURE__ */React__default.createElement("a", {
    href: "https://consumidorpositivo.onelink.me/3ote/x1wo22j1",
    target: "_blank"
  }, /* @__PURE__ */React__default.createElement("img", {
    className: "footer-cp__image",
    src: "https://www.consumidorpositivo.com.br/images/download-app-store.svg",
    alt: "Link para baixar o app na App Store",
    loading: "lazy",
    width: "205px",
    height: "64px"
  })))));
};
export { AppStores as default };